// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"question-answer_wrapper__Hjc0a","question":"question-answer_question__uZV3E","answer":"question-answer_answer__5BTPh"};